import { AddOutlined } from "@gds-react/icons";
import { Button, Icon } from "@gds-react/core";
import { DeviceBase, DeviceType } from "../../generated-api/device";
import { useState } from "react";
import { Popover } from "react-tiny-popover";
import {
  ContextMenuWrapper,
  DesktopLabel,
  MenuItem,
  MenuItemIcon,
  MenuItemText,
  MobileLabel,
  Seperator,
} from "./CreateDeviceButton.styles";
import CoreDeviceCreate from "@gf-core/widgets/widgets/CoreDeviceCreate";
import { useTranslation } from "react-i18next";

interface Props {
  installationId?: string;
  device?: DeviceBase;
  onSuccess?: () => void;
}

export default function CreateDeviceButton({
  device,
  installationId,
  onSuccess,
}: Props) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [deviceType, setDeviceType] = useState("");
  const [showContextMenu, setShowContextMenu] = useState(false);

  const renderPopupContent = () => {
    return (
      <ContextMenuWrapper>
        {device?.supportedSubDeviceTypes.map((type, index) => {
          const label = type === "VirtualDevice" ? "Pumps" : type;
          return (
            <div key={index}>
              <MenuItem
                onClick={() => {
                  setDeviceType(type);
                  setShowModal(true);
                }}
              >
                <MenuItemIcon></MenuItemIcon>
                <MenuItemText>{label}</MenuItemText>
              </MenuItem>
              {index !== 1 && <Seperator />}
            </div>
          );
        })}
      </ContextMenuWrapper>
    );
  };

  if (!device?.supportsSubDevices) return undefined;
  return (
    <>
      {device && device.supportedSubDeviceTypes.length === 1 ? (
        <Button
          onClick={() => {
            if (!device) return;
            setDeviceType(device?.supportedSubDeviceTypes[0]);
            setShowModal(true);
          }}
        >
          <Icon src={<AddOutlined />} />
          <MobileLabel>{t("createDeviceButton.buttonMobileText")}</MobileLabel>
          <DesktopLabel>
            {t("createDeviceButton.buttonDesktopText")}
          </DesktopLabel>
        </Button>
      ) : (
        <Popover
          isOpen={showContextMenu}
          positions={["bottom", "right"]}
          align="end"
          containerStyle={{ padding: "20px 0" }}
          content={renderPopupContent()}
          onClickOutside={() => setShowContextMenu(false)}
        >
          <Button onClick={() => setShowContextMenu(true)}>
            <Icon src={<AddOutlined />} />
            <MobileLabel>
              {t("createDeviceButton.buttonMobileText")}
            </MobileLabel>
            <DesktopLabel>
              {t("createDeviceButton.buttonDesktopText")}
            </DesktopLabel>
          </Button>
        </Popover>
      )}
      <CoreDeviceCreate
        installationId={installationId ?? ""}
        deviceTwinId={device.deviceTwinId ?? ""}
        deviceType={deviceType as DeviceType}
        show={showModal}
        onClose={() => {
          setDeviceType("");
          setShowModal(false);
          onSuccess?.();
        }}
      />
    </>
  );
}
